<template lang="pug">
layoutUpDown
  .pdb100pxScrollWrap.tinyScrollbarStyle(slot="middle")
    el-form.el-row(label-width="130px")
      el-col(:span="11")
        el-form-item(label="表单名称")
          el-input(v-model="rightModel.formName" disabled)
      el-col(:span="11")
        el-form-item(label="表单代码")
          el-input(v-model="rightModel.formCode" disabled)
      el-col(:span="11")
        el-form-item(label="表单模板" :required="isAdd")
          el-select(
            :disabled="!isAdd"
            @change="changeTemplate"
            v-model="rightModel.formTemplateType"
            style="width:100%;")
            template(v-for="(vv1, index1) in templateList")
              el-option(:value="vv1.key" :label="vv1.value")
      el-col(:span="11")
        el-form-item(label="表单类别")
          el-input(v-model="rightModel.formParentName" disabled)
      el-col(:span="22")
        el-form-item(label="关联费用类型")
          SelectMultiTreeFull(
            :disabled="!isEditAble"
            :valueList="rightModel.formExpenseTypes"
            :treeUrl="'/em/expenseType/transition/tree?disabled=false'"
            title="选择费用类型"
            placeholder="若不配置则该表单中所有启用状态的费用类型都可选择"
            @NewList="ExpenseTypesNewList"
            @DelOne="ExpenseTypesDelOne"
          )
      el-col(:span="22")
        el-form-item()
          el-checkbox(
            v-if="rightModel.parentCode === 'SQSQ'"
            :disabled="!isEditAble"
            v-model="rightModel.allowAmountZero") 允许单据的金额为0
          el-checkbox(
            v-else
            :disabled="!isEditAble"
            v-model="rightModel.followConfigRule") 按费用项配置记账规则
    .headTitle1
      .headTitle1Title 字段详情
    DetailTable(
      v-if="hasField"
      ref="theDetailTable"
      :rightModel="rightModel"
      :StandardTypeList="StandardTypeList"
      :isEditAble="isEditAble"
      )

  div(
    slot="down"
    style="text-align:center;padding:5px 5px 5px 0;")
    template(v-if="isAdd")
      template(v-if="rightModel.formTemplateType")
        el-button.refreshOrSaveBtn(@click="saveAdd()") 保存
        el-button.submitOrOtherBtn(@click="addExpenseItem()" icon="el-icon-plus") 新增费用项
      div(v-else style="font-size:13px;") 请选择 表单模板
    template(v-else-if="rightModelEdit")
      el-button(@click="CancelEdit()") 取消
      el-button.refreshOrSaveBtn(@click="saveUpdate()") 保存
      el-button.submitOrOtherBtn(@click="addExpenseItem()" icon="el-icon-plus") 新增费用项
    template(v-else)
      el-button.refreshOrSaveBtn(@click="rightModelEdit=true") 编辑
      el-button(@click="previewPop.isVisible=true") 预览表单

  sysDialog(
    width="80%"
    title="预览表单"
    :visible="previewPop.isVisible"
    @close="previewPop.isVisible=false"
    )
    DetailPreview(
      v-if="previewPop.isVisible"
      :formFieldConfigs="rightModel.formFieldConfigs")
    div(slot="btnArea" style="text-align:right;")
      el-button(@click="previewPop.isVisible=false") 取消

</template>

<script>
import apiAxios from '@/apiAxios.js'
import { cloneDeep } from '@/common/util/cloneDeep.js'
import DetailPreview from './DetailPreview.vue'
import DetailTable from './DetailTable.vue'
export default {
  components: {
    DetailPreview,
    DetailTable,
  },
  props: {
    requestType: null,
    rightModel: null,
    templateList: null,
  },
  computed: {
    isAdd() {
      return !(this.rightModel && this.rightModel.id)
    },
    isEditAble() {
      return this.isAdd || this.rightModelEdit
    },
    hasField() {
      return !!(
        this.rightModel &&
        this.rightModel.formFieldConfigs &&
        this.rightModel.formFieldConfigs.length
      )
    },
  },
  data() {
    return {
      rightModelEdit: false,
      StandardTypeList: [],

      previewPop: {
        isVisible: false,
      },
    }
  },
  methods: {
    CancelEdit() {
      this.$emit('ReloadItem')
      this.rightModelEdit = false
    },
    addExpenseItem() {
      const addOne = {
        newItem: true,
        alias: '',
        display: false,
        required: false,
        sort: 0,
        lineFeed: false,
        width: 0,
        expenseItemType: {
          name: '',
          standardType: null,
          controlType: null,
        },
        readOnly: false,
        expenseItem: true,
      }
      this.rightModel.formFieldConfigs.push(addOne)
      this.$refs.theDetailTable.popShow(addOne)
    },
    async changeTemplate(id) {
      await this.loadFieldList(id)
      await this.loadStandardTypeList(id)
    },
    async loadStandardTypeList(formTemplateType) {
      const { data } = await apiAxios.get(
        `/em/reimburseStandard/standardType/${formTemplateType}`
      )
      data.result.unshift({ key: null, value: '手工输入' })
      this.StandardTypeList = data.result
    },
    async loadFieldList(formTemplateType) {
      const { data } = await apiAxios.get(
        `/em/formDetail/template/${formTemplateType}/fields`
      )
      this.rightModel.formFieldConfigs = data.result
    },
    getPostModel() {
      const postModel = cloneDeep(this.rightModel)
      postModel.formExpenseTypes = postModel.formExpenseTypes.map(vv1 => ({
        expenseTypeId: vv1.id,
      }))
      if (this.isAdd) {
        delete postModel.id
      }
      return postModel
    },
    ExpenseTypesNewList(list1) {
      this.rightModel.formExpenseTypes = list1.map(vv1 => ({
        id: vv1.id,
        name: vv1.name,
      }))
    },
    ExpenseTypesDelOne(node, index) {
      this.rightModel.formExpenseTypes.splice(index, 1)
    },

    async saveAdd() {
      if (!this.rightModel.formTemplateType) {
        return this.$message.error(`请先选择 [表单模板]`)
      }
      const postModel = this.getPostModel()
      const { data } = await apiAxios.post(`/em/formDetail`, postModel)
      this.$message.success(data.message)
      this.CancelEdit()
    },
    async saveUpdate() {
      const postModel = this.getPostModel()
      const { id } = postModel
      const { data } = await apiAxios.put(`/em/formDetail/${id}`, postModel)
      this.$message.success(data.message)
      this.CancelEdit()
    },
  },
  async mounted() {
    if (this.rightModel.formTemplateType) {
      await this.loadStandardTypeList(this.rightModel.formTemplateType)
    }
  },
}
</script>
